import { useTranslation } from "react-i18next";
import { FCC } from "types";

import { PaymentProviderPicker } from "@/components/Portal/Documents/PaymentMethods/PaymentProviderPicker/PaymentProviderPicker";
import { DrCreditCardCardType } from "@/services/model";

type PaymentProviderProps = {
  sumIsZero: boolean;
  paymentProvider: DrCreditCardCardType | undefined;
  onChange: (s: DrCreditCardCardType | "") => void;
};

/**
 * Intro copy + payment-provider picker for checkout flows. Callers own the
 * surrounding ProfileCard so cards are never nested.
 */
export const PaymentProvider: FCC<PaymentProviderProps> = ({
  sumIsZero,
  paymentProvider,
  onChange,
}) => {
  const { t } = useTranslation();

  // PAYMENT METHOD IS ALWAYS MANDATORY FOR ALL CUSTOMERS (B2C and B2B)
  // - amount = 0: noCharge
  // - amount > 0: choosePayment
  const paymentText = sumIsZero
    ? t("Onboarding.sections.checkout.noCharge")
    : t("Onboarding.sections.checkout.choosePayment");

  return (
    <div
      data-testid="payment-provider-checkout"
      className="flex flex-col gap-4"
    >
      <p className="text-body-base text-foreground-primary">{paymentText}</p>
      <PaymentProviderPicker
        iconPlacement="inline"
        selected={paymentProvider}
        onChange={(s: DrCreditCardCardType) => {
          onChange(s);
        }}
      />
    </div>
  );
};
